import { tg } from './telegram';

export class ApiError extends Error {
  constructor(public code: string, message: string, public status: number) {
    super(message);
  }
}

const SESSION_KEY = 'onyx.session';
const DEV_KEY = 'onyx.devUser';

function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function setSession(token: string | null) {
  const s = storage();
  if (!s) return;
  if (token) s.setItem(SESSION_KEY, token);
  else s.removeItem(SESSION_KEY);
}

/** Local development: `?as=1002` signs in as another dev user (API must run with DEV_AUTH=1). */
function devUser(): string | null {
  if (!import.meta.env.DEV) return null;
  const fromUrl = new URLSearchParams(location.search).get('as');
  const s = storage();
  if (fromUrl) s?.setItem(DEV_KEY, fromUrl);
  return fromUrl ?? s?.getItem(DEV_KEY) ?? '1001';
}

export function authHeader(): string | null {
  if (tg?.initData) return `tma ${tg.initData}`;
  const session = storage()?.getItem(SESSION_KEY);
  if (session) return `Bearer ${session}`;
  const dev = devUser();
  return dev ? `dev ${dev}` : null;
}

export async function api<T>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const headers: Record<string, string> = {};
  const auth = authHeader();
  if (auth) headers.authorization = auth;
  if (init.body !== undefined) headers['content-type'] = 'application/json';
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: init.method ?? (init.body !== undefined ? 'POST' : 'GET'),
      headers,
      body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    });
  } catch {
    throw new ApiError('network', 'network', 0);
  }
  const data = (await res.json().catch(() => ({}))) as { error?: string; message?: string };
  if (!res.ok) throw new ApiError(data.error ?? 'internal', data.message ?? 'Request failed', res.status);
  return data as T;
}
